import { StateStream } from '@cgs/wge';

export const PAYTABLE_POPUP_COMPONENT_TOKEN = Symbol('PAYTABLE_POPUP_COMPONENT_TOKEN');

export abstract class PaytablePopupComponent {
  public readonly isShown: StateStream<boolean> = new StateStream(false);
  public abstract show(): void;
  public abstract hide(): void;
}
